import { Column } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
export var CombineOrdersIA = function CombineOrdersIA(_ref) {
  var shipInternational = _ref.shipInternational;
  if (shipInternational) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "9Brnnd",
      defaultMessage: [{
        "type": 0,
        "value": "Para combinar encomendas com envio internacional, tem de editar uma das encomendas e adicionar todos os artigos da outra encomenda. Depois de o fazer, pode cancelar a segunda encomenda e enviar as encomendas como uma só. Tenha em atenção que não pode combinar encomendas disponíveis para envio com pré-encomendas."
      }]
    })));
  } else {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "Nmy24O",
      defaultMessage: [{
        "type": 0,
        "value": "De momento, não pode combinar várias encomendas. Contacte-nos abaixo para obter assistência e poderemos adicionar as mesmas informações de acompanhamento a várias encomendas. Isto garante que o seu cliente pode aceder às informações de acompanhamento e que os envios são atualizados com precisão."
      }]
    })));
  }
};